module.exports = __webpack_public_path__ + "static/media/effective-peer-mentor.65eb3848.png";